const defaultStyle = {
  display: "block",
  backgroundColor: "white",
  width: "100%",
  padding: "0.5rem",
  textAlign: "left",
  text: "sm",
  fontFamily: "$content",
  border: "1px solid $colors$neutral_200",
  borderRadius: "0.375rem",
  "-moz-appearance": "none" /* Firefox */,
  "-webkit-appearance": "none" /* Safari and Chrome */,
  appearance: "none",
  backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>")`,
  backgroundRepeat: "no-repeat",
  backgroundPositionX: "98%",
  backgroundPositionY: "50%",
  "&:focus": {
    outline: "none",
    border: "1px solid $colors$primary_500",
  },
};

export const stitchesSelectStyles = {
  ...defaultStyle,
  variants: {},
};
